import React from 'react';
import { Box, Container, Typography, IconButton, useTheme as useMuiTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CodeIcon from '@mui/icons-material/Code';

// Styled components
const FooterContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'light' 
    ? 'rgba(0, 0, 0, 0.05)' 
    : 'rgba(255, 255, 255, 0.05)',
  padding: theme.spacing(4, 0),
  position: 'relative',
}));

const ScrollToTopButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '-25px',
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: theme.palette.primary.main,
  color: '#fff',
  borderRadius: '50%',
  padding: theme.spacing(1),
  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    transform: 'translateX(-50%) translateY(-5px)',
  },
  transition: 'all 0.3s ease',
}));

const HeartIcon = styled(FavoriteIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '0.9rem',
  verticalAlign: 'middle',
  margin: '0 4px',
  animation: 'heartBeat 1.5s infinite',
  '@keyframes heartBeat': {
    '0%': {
      transform: 'scale(1)',
    },
    '14%': {
      transform: 'scale(1.3)',
    },
    '28%': {
      transform: 'scale(1)',
    },
    '42%': {
      transform: 'scale(1.3)',
    },
    '70%': {
      transform: 'scale(1)',
    },
  },
}));

const CodeIconStyled = styled(CodeIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '1rem',
  verticalAlign: 'middle',
  margin: '0 4px',
}));

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <FooterContainer>
      <Container maxWidth="lg">
        <ScrollToTopButton
          onClick={handleScrollToTop}
        >
          <KeyboardArrowUpIcon />
        </ScrollToTopButton>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              Copyright © {currentYear} Sivagnanam Maheshwaran. All rights reserved.
            </Typography>
            <Typography 
              variant="body2" 
              color="text.secondary"
              sx={{ mt: 1 }}
            >
              Designed with <HeartIcon /> and <CodeIconStyled /> by Maheshwaran
            </Typography>
          </Box>
        </motion.div>
      </Container>
    </FooterContainer>
  );
};

export default Footer; 